export default __webpack_public_path__ + "static/media/placeholder_dummy2016-deko01-de.79f7c1ef.png";